"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutCompany() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section id="aboutcompany" className="bg-background py-16 px-4 md:px-8 lg:py-24 light">
      <div ref={ref} className={`mx-auto max-w-4xl flex flex-col items-center justify-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="mb-8 text-center text-4xl font-bold text-foreground md:text-5xl font-default">
          Մեր Մասին
        </h2>
        <p className="leading-relaxed text-muted-foreground font-serif !text-2xl !w-[1200px] !font-semibold !text-justify">«Գեոկոսմոս» փակ բաժնետիրական ընկերությունը հիմնադրվել է 2017թ. նոյեմբերի 16-ին՝ ՀՀ կառավարության N 1478-Ա որոշմամբ։ ՀՀ կառավարության 2022թ. մարտի 10-ի N 294-Ա որոշմամբ ընկերության բաժնետոմսերի կառավարումը լիազորվել է ՀՀ բարձր տեխնոլոգիական արդյունաբերության նախարարությանը և 2021թ. հոկտեմբերի 21-ին «Գեոկոսմոս» ՓԲԸ-ն ստացել է տիեզերական գործունեություն իրականացնելու համար Հայաստանում առաջին լիցենզիան:</p>
      </div>
    </section>;
}